export interface Testimonial {
  emoji: string;
  name: string;
  role: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    emoji: "😆",
    name: "追更狂魔·阿澈",
    role: "连载爱好者",
    content: "每天睡前不看一话反转剧都睡不踏实，更新是真快，笑点也是真密，已成功安利全宿舍入坑。",
  },
  {
    emoji: "🤣",
    name: "摸鱼冠军·小舟",
    role: "打工人",
    content: "加班修仙那部简直是我本人，一边看一边笑到隔壁工位来围观。魔性画风越看越上头，根本停不下来。",
  },
  {
    emoji: "😄",
    name: "漫龄十年·老白",
    role: "资深漫友",
    content: "看了这么多年，歪歪的分类做得是真清楚，脑洞和神展开的质量稳定，很少有踩雷的。推荐得很有底气。",
  },
  {
    emoji: "🥳",
    name: "快乐传播者·KK",
    role: "学生党",
    content: "把喜欢的爆笑名场面截图发班级群，全班一起乐，连班主任都让我多发点。是真正的快乐源泉。",
  },
];